import React from 'react';
interface LogoProps {
  tone?: 'light' | 'dark';
  className?: string;
}
export function Logo({
  tone = 'light',
  className = ''
}: LogoProps) {
  const text = tone === 'light' ? 'text-white' : 'text-ink-900';
  const disc = tone === 'light' ? 'fill-white/10 stroke-white' : 'fill-brand-600 stroke-brand-600';
  const grid = tone === 'light' ? 'stroke-white/85' : 'stroke-white';
  return <span className={`flex items-center gap-2.5 ${className}`} data-id="element-121" data-mp="mt4856tlh28y">
      <svg viewBox="0 0 32 32" className="h-8 w-8" fill="none" aria-hidden="true" data-id="element-122" data-mp="mqrqkurr0twf">
        <circle cx="16" cy="16" r="14.5" className={disc} strokeWidth="1.5" data-id="element-123" data-mp="rrfj5kvmlisr" />
        <g className={grid} strokeWidth="1.3" strokeLinecap="round" data-id="element-124" data-mp="dr4qqdeo3w5h">
          <ellipse cx="16" cy="16" rx="5.6" ry="14.5" data-id="element-125" data-mp="hthw30pi5s1q" />
          <path d="M16 1.5v29" data-id="element-126" data-mp="hrydv4kad6xb" />
          <path d="M1.5 16h29" data-id="element-127" data-mp="2yif04g1or0w1" />
          <path d="M4 8.5c3.4 1.4 7.6 2.1 12 2.1s8.6-.7 12-2.1" data-id="element-128" data-mp="2yhc6i0czakcf" />
          <path d="M4 23.5c3.4-1.4 7.6-2.1 12-2.1s8.6.7 12 2.1" data-id="element-129" data-mp="32jqpqlkk7m48" />
        </g>
      </svg>
      <span className={`text-[19px] font-semibold tracking-[-0.01em] ${text}`} data-id="element-130" data-mp="32hnt3iowiuqj">
        Elyon Markets
      </span>
    </span>;
}